import React, {useContext, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Context} from '..';
import {AuthenticatedWebSocket} from './authenticatedWebSocket';
import {WS_LOGS_URL} from './config';

const WsAPI = observer(() => {
    const {user} = useContext(Context);

    useEffect(() => {
        const socket = new AuthenticatedWebSocket({
            url: WS_LOGS_URL,
            name: 'Logs WebSocket',
            onMessage: (event) => {
                let data;

                try {
                    data = JSON.parse(event.data);
                } catch (error) {
                    console.error('Logs WebSocket: ошибка парсинга JSON', event.data);
                    return;
                }

                if (data?.log) {
                    user.setLog({
                        log: data.log,
                        data: [data.data],
                    });
                    return;
                }

                if (data?.player_info) {
                    user.setPlayerInfo({
                        player_info: data.player_info,
                        data: [data.data],
                    });
                }
            },
        });

        socket.connect();

        return () => {
            socket.stop();
        };
    }, [user]);

    return null;
});

export default WsAPI;
